import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Label, Input, FormGroup } from 'reactstrap';
import { TournamentTicketStatus } from '@repo/common-types';

interface FilterState {
  status?: TournamentTicketStatus[];
  createdAt?: { from?: Date; to?: Date };
}

interface TournamentTicketsFilterProps {
  onClose: () => void;
  onApplyFilters: (filters: FilterState) => void;
  currentFilters: FilterState;
}

export const TournamentTicketsFilter: React.FC<TournamentTicketsFilterProps> = ({
  onClose,
  onApplyFilters,
  currentFilters,
}) => {
  const [statusFilters, setStatusFilters] = useState<TournamentTicketStatus[]>(currentFilters.status || []);
  const [createdAtFrom, setCreatedAtFrom] = useState<string>(
    currentFilters.createdAt?.from ? new Date(currentFilters.createdAt.from).toISOString().split('T')[0] : '',
  );
  const [createdAtTo, setCreatedAtTo] = useState<string>(
    currentFilters.createdAt?.to ? new Date(currentFilters.createdAt.to).toISOString().split('T')[0] : '',
  );

  const handleStatusToggle = (status: TournamentTicketStatus) => {
    setStatusFilters((prev) => {
      if (prev.includes(status)) {
        return prev.filter((s) => s !== status);
      } else {
        return [...prev, status];
      }
    });
  };

  const handleApply = () => {
    const filters: FilterState = {
      status: statusFilters.length > 0 ? statusFilters : undefined,
      createdAt:
        createdAtFrom || createdAtTo
          ? {
              from: createdAtFrom ? new Date(createdAtFrom) : undefined,
              to: createdAtTo ? new Date(createdAtTo) : undefined,
            }
          : undefined,
    };
    onApplyFilters(filters);
  };

  const handleReset = () => {
    setStatusFilters([]);
    setCreatedAtFrom('');
    setCreatedAtTo('');
  };

  return (
    <Modal isOpen={true} toggle={onClose} size="md">
      <ModalHeader toggle={onClose}>Filter Tournament Tickets</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label className="fw-semibold">Status</Label>
          <div className="d-flex flex-column gap-2">
            {Object.values(TournamentTicketStatus).map((status) => (
              <div key={status} className="form-check">
                <Input
                  type="checkbox"
                  id={`status-${status}`}
                  checked={statusFilters.includes(status)}
                  onChange={() => handleStatusToggle(status)}
                  className="form-check-input"
                />
                <Label for={`status-${status}`} className="form-check-label text-capitalize">
                  {status}
                </Label>
              </div>
            ))}
          </div>
        </FormGroup>

        <FormGroup>
          <Label className="fw-semibold">Created At Date Range</Label>
          <div className="d-flex align-items-center gap-2">
            <Input
              type="date"
              value={createdAtFrom}
              onChange={(e) => setCreatedAtFrom(e.target.value)}
              placeholder="From"
            />
            <span>to</span>
            <Input type="date" value={createdAtTo} onChange={(e) => setCreatedAtTo(e.target.value)} placeholder="To" />
          </div>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={handleReset}>
          Reset
        </Button>
        <Button color="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleApply}>
          Apply Filters
        </Button>
      </ModalFooter>
    </Modal>
  );
};
